module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-HeavyOblique.842cf52e.ttf";